import { useWindowSize } from "usehooks-ts";
import {
	ADAPTIVE_STATES,
	BREAKPOINTS_SIZES
} from "../constants/ADAPTIVE_STATES";

const useAdaptiveState = () => {
	const { width } = useWindowSize();

	if (width <= BREAKPOINTS_SIZES.MOBILE) {
		return ADAPTIVE_STATES.MOBILE;
	}

	if (width <= BREAKPOINTS_SIZES.TABLET) {
		return ADAPTIVE_STATES.TABLET;
	}

	return ADAPTIVE_STATES.DESKTOP;
};

export default useAdaptiveState;
